import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
var buildRceConfigUrl = function buildRceConfigUrl(host, contextType, contextId) {
  var base = host.match(/^https?:\/\//) ? host : "".concat(window.location.protocol, "//").concat(host);
  var url = new URL('/api/rceConfig', base);
  contextType && url.searchParams.append('contextType', contextType);
  contextId && url.searchParams.append('contextId', contextId);
  return url;
};
export var fetchRceConfig = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(rcsHost, contextType, contextId, jwt) {
    var rceConfigUrl, response;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          rceConfigUrl = buildRceConfigUrl(rcsHost, contextType, contextId);
          _context.next = 3;
          return fetch(rceConfigUrl.href, {
            headers: {
              Authorization: "Bearer ".concat(jwt)
            }
          });
        case 3:
          response = _context.sent;
          if (response.ok) {
            _context.next = 6;
            break;
          }
          throw "Failed to fetch, response status: ".concat(response.status);
        case 6:
          _context.next = 8;
          return response.json();
        case 8:
          return _context.abrupt("return", _context.sent);
        case 9:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function fetchRceConfig(_x, _x2, _x3, _x4) {
    return _ref.apply(this, arguments);
  };
}();